module.exports = __webpack_public_path__ + "img/Candy.4854d138.webp";